import React from "react";
import Meta from "../Meta";
import PageHeader from "../components/PageHeader";
import Loader from "../loader";
import { applyLang } from "../../../i18n";
import { Carousel } from "antd";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { resolveImage } from "../utils";

const styles = `
.t26-actu-detail {
  padding: 0 clamp(16px, 4vw, 32px) clamp(40px, 6vw, 80px);
  max-width: 860px;
  margin-inline: auto;
}
.t26-actu-detail__lead-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: clamp(18px, 2vw, 24px);
  object-fit: cover;
  margin-bottom: 24px;
  box-shadow: var(--shadow-md);
}
.t26-actu-detail__content {
  font-size: 17px; line-height: 1.75;
  color: var(--ink-2);
}
.t26-actu-detail__content h2, .t26-actu-detail__content h3 {
  font-family: var(--font-display);
  color: var(--ink);
  margin: 28px 0 12px;
}
.t26-actu-detail__content p { margin: 0 0 14px; }
.t26-actu-detail__content img { max-width: 100%; height: auto; border-radius: var(--r-md); }
.t26-actu-detail__content a { color: var(--primary); text-decoration: underline; }
.t26-actu-detail__carousel { margin-bottom: 24px; border-radius: clamp(18px, 2vw, 24px); overflow: hidden; }
.t26-actu-detail__carousel img { width: 100%; aspect-ratio: 16/9; object-fit: cover; }
`;

export default class ActuDetail extends React.Component {
    componentDidMount() {
        const context = this.props.context;
        const { data } = context;
        if (!data || data.length === 0) return;
        const actu = applyLang(data[0], context.lang);
        if (actu.link) {
            window.location.href = actu.link;
        }
    }

    render() {
        const context = this.props.context;
        const { org, data } = context;

        if (this.props.loading) {
            return (
                <>
                    <Meta context={context} title={t`Article`} />
                    <Loader />
                </>
            );
        }

        if (!data || data.length === 0) {
            return (
                <>
                    <Meta context={context} title={t`Article introuvable`} noindex />
                    <div style={{ padding: 60, textAlign: "center", color: "var(--ink-3)" }}>
                        <Trans>Cet article n'a pas été trouvé.</Trans>
                    </div>
                </>
            );
        }

        const actu = applyLang(data[0], context.lang);
        if (actu.link) return null; // redirection en cours

        const title = actu.title;
        const description = actu.description;
        const leadImage = actu.type === "IMAGE" && Array.isArray(actu.images) && actu.images.length > 0
            ? resolveImage(actu.images[0])
            : null;

        return (
            <>
                <Meta context={context} title={title} description={description} image={leadImage} />
                <style dangerouslySetInnerHTML={{ __html: styles }} />

                <PageHeader
                    title={title}
                    subtitle={description}
                    crumbs={[
                        { label: t`Accueil`, url: org.BASE_WEB_URL },
                        { label: t`Actualités`, url: org.BASE_WEB_URL + "/actualites" },
                        { label: title },
                    ]}
                />

                <article className="t26-actu-detail">
                    {actu.type === "IMAGE" && Array.isArray(actu.images) && actu.images.length === 1 && (
                        <img src={resolveImage(actu.images[0])} alt={title} className="t26-actu-detail__lead-img" />
                    )}
                    {actu.type === "IMAGE" && Array.isArray(actu.images) && actu.images.length > 1 && (
                        <Carousel className="t26-actu-detail__carousel" autoplay>
                            {actu.images.map((src, i) => (
                                <div key={i}><img src={resolveImage(src)} alt="" /></div>
                            ))}
                        </Carousel>
                    )}
                    {actu.content && (
                        <div className="t26-actu-detail__content" dangerouslySetInnerHTML={{ __html: actu.content }} />
                    )}
                </article>
            </>
        );
    }
}
